import { graphql, useStaticQuery } from "gatsby";
import React from "react";

const SEO = ({ description, lang, title, seo, seoData, acfSEO }) => {
  const { wp, allWp } = useStaticQuery(graphql/* GraphQL */ `
    query {
      wp {
        generalSettings {
          title
          description
        }
      }
      allWp {
        ...seoAllFragment
      }
    }
  `);

  const staticSEO = allWp.edges[0].node.seo;

  let meta = [];
  const metaDescription =
    description || seo?.metaDesc || wp.generalSettings?.description;
  const defaultTitle = seo?.title || wp.generalSettings?.title || title;

  let robots = [];
  seo?.metaRobotsNoindex
    ? robots.push(seo?.metaRobotsNoindex)
    : robots.push("index");
  seo?.metaRobotsNofollow
    ? robots.push(seo?.metaRobotsNofollow)
    : robots.push("follow");

  if (robots.length) {
    meta.push({
      name: "robots",
      content: robots.join(", ").replace(/^,|,$/g, "").trim(),
    });
  }

  if (seo?.opengraphImage?.imgixImage?.fluid) {
    const src = seo.opengraphImage.imgixImage.fluid.srcWebp;
    meta.push({ name: "og:image", src });
  } else if (staticSEO.social.facebook.defaultImage?.localFile) {
    const src =
      staticSEO.social.facebook.defaultImage.imgixImage.fluid.srcWebp;
    meta.push({ name: "og:image", content: src });
  }

  if (seo?.twitterImage?.imgixImage?.fluid) {
    const src = `${seo.twitterImage.imgixImage.fluid.srcWebp}`;
    meta.push({ name: "twitter:image", content: src });
  }

  const getPageSchema = () => {
    return seoData ? (
      <script type="application/ld+json">{seoData}</script>
    ) : null;
  };

  return (
    <>
      <title>{defaultTitle}</title>

      {/* ✅ Safe meta description insertion */}
      {!meta.some(m => m.name === "description") && (
        <meta name="description" content={metaDescription} />
      )}

      <meta
        property="og:title"
        content={seo?.opengraphTitle || defaultTitle}
      />
      <meta
        property="og:description"
        content={seo?.opengraphDescription || metaDescription}
      />
      <meta property="og:type" content={seo?.opengraphType || "website"} />
      <meta property="og:url" content={seo?.opengraphUrl || ""} />
      <meta
        property="og:site_name"
        content={seo?.opengraphSiteName || defaultTitle}
      />
      <meta name="twitter:card" content="summary" />
      <meta
        name="twitter:creator"
        content={
          staticSEO.social.twitter.username
            ? `@${staticSEO.social.twitter.username}`
            : ""
        }
      />
      <meta
        name="twitter:title"
        content={seo?.twitterTitle || defaultTitle}
      />
      <meta
        name="twitter:description"
        content={seo?.twitterDescription || metaDescription}
      />
      {getPageSchema(acfSEO?.seoPageSchema)}
      {meta.map((item, index) => (
        <meta key={index} name={item.name} content={item.content} />
      ))}
    </>
  );
};

export default SEO;


